<span class="a-text-danger a-font-14 font-weight-bold" *ngIf="field.isRequired">
    *
</span>